import React from 'react';

import classes from './DailyFeedbackDropdown.module.css';

import DropDownIcon from '../../../assets/icons/dropdown-arrow-blue.svg';
import { IsListEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
// import Backdrop from '../Backdrop/Backdrop';
import LinesEllipsis from 'react-lines-ellipsis';

class DailyFeedbackDropdown extends React.Component {

    state = {
        itemsList: [],
        activeItemPos: 0,
        dropdownOpen: false,
        activeItemName: ''
    }

    onDropdownItemClicked = (pos) => {
        const activeItemName = this.props.forWeekly ? this.state.itemsList[pos].name : this.state.itemsList[pos].topicName;
        this.setState({ activeItemPos: pos, activeItemName: activeItemName, dropdownOpen: false });
        this.props.dropdownItemClicked(pos);
    }

    onDropdownClicked = () => {
        let status = this.state.dropdownOpen;
        this.setState({ dropdownOpen: !status });
    }

    componentDidMount() {
        let items = []
        // console.log(this.props.dropdownItemsList)
        if (this.props.dropdownItemsList === []) {
            items = [{
                id: 0,
                topicName: 'Topics',
                date: ''
            }]

        } else {
            items = this.props.dropdownItemsList
        }
        const activeItemName = this.props.forWeekly ? this.props.dropdownItemsList[0].name : items[0].topicName;
        this.setState({ itemsList: items, activeItemPos: 0, activeItemName: activeItemName, dropdownOpen: false });
    }

    componentDidUpdate(prevProps) {
        let items = []
        if (this.props.dropdownItemsList === []) {
            items = [{
                id: 0,
                topicName: 'Topics',
                date: ''
            }]
        } else {
            items = this.props.dropdownItemsList
        }
        if (prevProps.dropdownItemsList !== this.props.dropdownItemsList) {
            const activeItemName = this.props.forWeekly
                ? this.props.dropdownItemsList[this.props.activeItemPos].name
                : items[this.props.activeItemPos].topicName;
            // : this.props.dropdownItemsList[this.props.activeItemPos].topicName;

            this.setState({ itemsList: items, activeItemName: activeItemName, activeItemPos: 0, dropdownOpen: false });
        }
        if (prevProps.activeItemPos !== this.props.activeItemPos) {
            const activeItemName = this.props.forWeekly
                ? this.props.dropdownItemsList[this.props.activeItemPos].name
                : this.props.dropdownItemsList[this.props.activeItemPos < 0 ? 0 : this.props.activeItemPos].topicName;
            this.setState({ activeItemPos: this.props.activeItemPos, activeItemName: activeItemName, dropdownOpen: false });
        }
    }

    render() {

        const renderTopicsList = !IsListEmpty(this.state.itemsList) ? this.state.itemsList.map((item, index) => {
            return (
                <li key={index}
                    className={[classes.Item, index === 0 ? classes.FullWidth : '', index === this.state.activeItemPos ? classes.Active : ''].join(' ')}
                    onClick={() => this.onDropdownItemClicked(index)}>
                    <p className={classes.TopicName} title={item.topicName}>
                        <LinesEllipsis
                            text={item.topicName}
                            maxLine='1'
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                        />
                        {/* /{item.topicName} */}
                    </p>
                    <span className={classes.TopicDate}>{item.date}</span>
                </li>
            );
        }) : <li className={classes.Item}>
            <p className={classes.TopicName}>Topics Not Available</p>
        </li>

        const renderWeeksList = !IsListEmpty(this.state.itemsList) ? this.state.itemsList.map((item, index) => {
            return (
                <li key={index}
                    className={[classes.Item, classes.FullWidth,
                    index === this.state.activeItemPos ? classes.Active : ''].join(' ')}
                    onClick={() => this.onDropdownItemClicked(index)}>
                    <p className={classes.TopicName} title={item.topicName}>
                        {!IsStringEmpty(item.name) ? item.name.split(' | ')[0] : '-'}
                        <span className={classes.WeekDate}>{!IsStringEmpty(item.name) ? item.name.split(' | ')[1] : '-'}</span>
                    </p>
                </li>
            );
        }) : <li className={classes.Item}>
            <p className={classes.TopicName}>Topics Not Available</p>
        </li>

        return (
            <>
                {/* <Backdrop visible={this.state.dropdownOpen} transparent={true} backdropClicked={this.onDropdownClicked} /> */}
                {
                    this.props.forWeekly !== true
                        ? <div className={classes.DropdownComponentContainer}>
                            <div className={classes.SelectedTopicContainer}>
                                <p className={classes.SubText}>Select Topic</p>
                                <div className={classes.SelectedTopicDiv} onClick={this.onDropdownClicked}>
                                    <h3 className={classes.SelectedTopicName}>{this.state.activeItemName}</h3>
                                    <img src={DropDownIcon} alt="Daily Feedback Dropdown" className={[classes.DropDownIcon, this.state.dropdownOpen ? classes.Open : ''].join(' ')} />
                                </div>
                            </div>
                            {
                                this.state.dropdownOpen
                                    ?
                                    <div className={classes.ItemsListContainer}>
                                        <p className={classes.ListHeading}>Select Topic</p>
                                        <ul className={classes.ItemsList}>
                                            {renderTopicsList}
                                        </ul>
                                    </div>
                                    : null
                            }
                        </div>
                        : <div className={classes.DropdownComponentContainer}>
                            <div className={classes.SelectedTopicContainer}>
                                <p className={classes.SubText}>Select Week</p>
                                <div className={classes.SelectedTopicDiv} onClick={this.onDropdownClicked}>
                                    <h3 className={classes.SelectedTopicName}>{this.state.activeItemName}</h3>
                                    <img src={DropDownIcon} alt="Weekly Feedback Dropdown" className={[classes.DropDownIcon, this.state.dropdownOpen ? classes.Open : ''].join(' ')} />
                                </div>
                            </div>
                            {
                                this.state.dropdownOpen && this.props.forWeekly
                                    ?
                                    <div className={classes.ItemsListContainer}>
                                        <ul className={classes.WeekItemsList}>
                                            {renderWeeksList}
                                        </ul>
                                    </div>
                                    : null
                            }
                        </div>
                }
            </>
        );
    }
}

export default DailyFeedbackDropdown;